import { Stack } from "@mui/material";
import SelectInput from "components/files/SelectInput";
import SwitchInput from "components/files/SwitchInput";
import TextInput from "components/files/TextInput";
import NullCheck from "components/NullCheck";
import { LANGUAGES_LIST } from "config/const";
import { ROLES_ID } from "config/roles";
import { useDispatch, useSelector } from "react-redux";
import { setPaletteMode } from "store/userSettingsSlice";

const Details = ({ control, errors, handleClickLang, logOut }) => {
    const dispatch = useDispatch()
    const userRole = useSelector((state) => state.userSettings?.user?.userRole);

    const PALETTE_MODE = [
        { id: "dark", name: "Dark" },
        { id: "light", name: "Light" },
    ]

    return (
        <Stack spacing={3}>
            <TextInput
                fullWidth
                required
                errors={errors}
                name="userName"
                title="USER_NAME"
                disabled
                control={control}
            />

            <Stack direction="row" spacing={2}>
                <TextInput
                    required
                    addFlex
                    errors={errors}
                    name="fn"
                    title="FN"
                    control={control}
                />
                <TextInput
                    required
                    addFlex
                    errors={errors}
                    name="ln"
                    title="LN"
                    control={control}
                />
            </Stack>
            <Stack direction="row" spacing={2}>

                <TextInput
                    addFlex
                    errors={errors}
                    name="email"
                    title="EMAIL"
                    control={control}
                    disabled={userRole === ROLES_ID.TECHNICIAN}
                />

                <TextInput
                    required
                    addFlex
                    errors={errors}
                    name="tel"
                    title="TEL"
                    control={control}
                />
            </Stack>

            <Stack direction="row" spacing={2}>
                <SelectInput
                    width="100%"
                    name="lang"
                    title="LANG"
                    addFlex
                    errors={errors}
                    control={control}
                    onChanged={handleClickLang}
                    options={LANGUAGES_LIST?.map(lang => ({ ...lang, name: lang?.i18Key }))}
                />
                <SelectInput
                    width="100%"
                    name="userPaletteMode"
                    title="USER_PALETTE_MODE"
                    addFlex
                    errors={errors}
                    control={control}
                    onChanged={(i) => dispatch(setPaletteMode(i?.id))}
                    options={PALETTE_MODE}
                />
            </Stack>
            <SwitchInput
                name="hideFloatingNotifications"
                title="HIDE_FLOATING_NOTIFICATIONS"
                errors={errors}
                control={control}
            />
        </Stack>
    )
}
export default Details;